import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, COOKIE_CREDENTIALS } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? m[1] : null;
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid }, COOKIE_CREDENTIALS);
        setUser(data.user);
        // strip hash and navigate to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login?error=oauth", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F1115] text-slate-200" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 border-2 border-[#FF6A00] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm tracking-[0.2em] uppercase font-semibold text-slate-400">
          Verifying session
        </p>
      </div>
    </div>
  );
}
